import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonStyle } from '../../styles/styles';

type ButtonProps = {
  children?: React.ReactNode,
  onClick: () => void,
  width?: string,
  height?: string,
  filledStyle?: boolean,
  buttonStyle?: string,
  padding?: string,
  icon?: any, // FontAwesomeIcon type
  disabled?: boolean,
};

function Button({
  children,
  onClick,
  width,
  height,
  filledStyle,
  buttonStyle,
  padding,
  icon,
  disabled = false,
}: ButtonProps) {
  return (
    <ButtonStyle
      onClick={onClick}
      width={width}
      height={height}
      filledStyle={filledStyle}
      buttonStyle={buttonStyle}
      padding={padding}
      disabled={disabled}
    >
      {icon && <FontAwesomeIcon icon={icon}/>}
      {children}
    </ButtonStyle>
  );
}

export default Button;